/* ============================================================
   ROAM HAVEN — scroll interactions
   Load this on every page via theme.liquid, right before </body>
   (see setup instructions). Uses rh- prefixed classes only.
   ============================================================ */
(function(){
  var BOOT_SVG = '<svg viewBox="0 0 40 90" xmlns="http://www.w3.org/2000/svg"><path d="M20 2C11 2 6 13 6 25c0 8 3 13 3 21 0 9-5 13-5 23 0 11 8 17 16 17s16-6 16-17c0-10-5-14-5-23 0-8 3-13 3-21C34 13 29 2 20 2z"/></svg>';

  /* ---------- BOOT PRINT TRAIL ---------- */
  var trail = document.getElementById('rhBootTrail');
  var prints = [];
  function buildTrail(){
    if(!trail) return;
    trail.innerHTML = '';
    prints = [];
    var docHeight = document.body.scrollHeight;
    var step = 230;
    var count = Math.floor(docHeight / step);
    var baseLeft = 46;
    for(var i=0; i<count; i++){
      var wrap = document.createElement('div');
      wrap.className = 'rh-boot-print';
      var curve = Math.sin(i * 0.45) * 22;
      var footOffset = (i % 2 === 0) ? -16 : 16;
      var left = baseLeft + curve + footOffset;
      var top = 120 + i * step;
      var rotate = (i % 2 === 0 ? -10 : 10) + Math.sin(i * 0.3) * 4;
      var flip = (i % 2 === 0) ? 1 : -1;
      wrap.style.top = top + 'px';
      wrap.style.left = left + 'px';
      wrap.style.transform = 'rotate(' + rotate + 'deg) scaleX(' + flip + ')';
      var dust = document.createElement('div');
      dust.className = 'rh-dust-smudge';
      wrap.appendChild(dust);
      var svgHolder = document.createElement('div');
      svgHolder.innerHTML = BOOT_SVG;
      wrap.appendChild(svgHolder.firstChild);
      trail.appendChild(wrap);
      prints.push(wrap);
    }
    observePrints();
  }

  var printObserver;
  function observePrints(){
    if(printObserver) printObserver.disconnect();
    printObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){ entry.target.classList.add('rh-visible'); }
      });
    }, { rootMargin: '0px 0px -35% 0px', threshold: 0.01 });
    prints.forEach(function(p){ printObserver.observe(p); });
  }

  /* ---------- STAMP-IN CATEGORY / PRODUCT CARDS ---------- */
  function initStampIn(){
    var cards = document.querySelectorAll('.rh-cat-card');
    if(!cards.length) return;
    var cardObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var el = entry.target;
          var delay = Array.prototype.indexOf.call(cards, el) % 3 * 90;
          setTimeout(function(){ el.classList.add('rh-stamp-in'); }, delay);
          cardObserver.unobserve(el);
        }
      });
    }, { threshold: 0.25 });
    cards.forEach(function(c){ cardObserver.observe(c); });
  }

  /* ---------- COMPASS + TOPO PARALLAX ON SCROLL ---------- */
  var ticking = false;
  function onScroll(){
    if(!ticking){
      window.requestAnimationFrame(function(){
        var needle = document.getElementById('rhCompassNeedle');
        var topoLayers = document.querySelectorAll('.rh-topo');
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var docHeight = document.body.scrollHeight - window.innerHeight;
        var pct = docHeight > 0 ? scrollTop / docHeight : 0;

        if(needle){ needle.style.transform = 'rotate(' + (pct * 340) + 'deg)'; }
        topoLayers.forEach(function(layer, i){
          var factor = 0.05 + (i % 3) * 0.015;
          layer.style.backgroundPosition = '0px ' + (scrollTop * factor) + 'px';
        });
        ticking = false;
      });
      ticking = true;
    }
  }

  function init(){
    buildTrail();
    initStampIn();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', function(){
      clearTimeout(window.__rhResize);
      window.__rhResize = setTimeout(buildTrail, 250);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function(){ buildTrail(); onScroll(); });
})();
